type FilterButtonInterface = {
    label: string;
    onClick: () => void;
    active?: boolean;
    disabled?: boolean;
};

const FilterButton = ({
    label,
    onClick,
    active = false,
    disabled = false,
}: FilterButtonInterface) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`default-transition button button--sm button--pill${active ? '' : ' button--outline'}`}
        >
            {label}
        </button>
    );
};

export default FilterButton;